var React = require('react');

function Record (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 39c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm0 3c9.941 0 18-8.059 18-18S33.941 6 24 6 6 14.059 6 24s8.059 18 18 18z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 29a5 5 0 100-10 5 5 0 000 10zm0 3a8 8 0 100-16 8 8 0 000 16z","key":1})]);
}

Record.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Record;

Record.default = Record;
